import React from 'react'
import { LineProps } from './Type'
import { useStyle } from './Style'

const Line: React.FC<LineProps> = ({ marginTopBottom }): React.ReactElement => {
  const classes = useStyle({ marginTopBottom })
  return <div className={classes.line} />
}

export default Line
